"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const logo_png_1 = __importDefault(require("../../../../assets/logo.png"));
const doshx_controls_web_1 = require("doshx_controls_web");
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const console_1 = require("../../../../reducers/slices/console");
const get_document_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_document_thunk");
const scaleFunction_1 = require("../../../../helpers/scaleFunction");
const axios_1 = __importDefault(require("axios"));
const get_document_elements_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_document_elements_thunk");
function CertificatePage({ isPrint }) {
    const { document_id } = (0, react_router_dom_1.useParams)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const certificateRef = (0, react_1.useRef)(null);
    const { selectedDocument, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, token } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [signers, setSigners] = (0, react_1.useState)([]);
    const [qrCodeUrl, setQrCodeUrl] = (0, react_1.useState)(null);
    const pages = Number.isFinite(Number(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.pages)) ? Number(selectedDocument.pages) + 1 : 1;
    (0, react_1.useEffect)(() => {
        dispatch((0, console_1.setPageTitle)("Certificate"));
        if (screen.width < 1900) {
            dispatch((0, console_1.setShowMenu)(false));
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (token) {
            if (document_id && !selectedDocument) {
                dispatch((0, get_document_thunk_1.get_document_thunk)({
                    data: {
                        _id: document_id,
                    },
                }));
            }
        }
    }, [token]);
    (0, react_1.useEffect)(() => {
        if (selectedDocument) {
            if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers.length) > 0) {
                // Map signers and enrich current user's signer data with their facetecDBRef
                const enrichedSigners = selectedDocument.signers.map((signer) => {
                    if (signer.email === (user === null || user === void 0 ? void 0 : user.email)) {
                        // For current user, ensure we have their facetecDBRef from user state
                        return Object.assign(Object.assign({}, signer), { facetecDBRef: signer.facetecDBRef || (user === null || user === void 0 ? void 0 : user.facetecDBRef) });
                    }
                    return signer;
                });
                setSigners(enrichedSigners);
            }
            else {
                setSigners([
                    {
                        first_name: user === null || user === void 0 ? void 0 : user.name,
                        last_name: user === null || user === void 0 ? void 0 : user.surname,
                        email: user === null || user === void 0 ? void 0 : user.email,
                        facetecDBRef: user === null || user === void 0 ? void 0 : user.facetecDBRef,
                    },
                ]);
            }
        }
    }, [selectedDocument, user]);
    (0, react_1.useEffect)(() => {
        if (document_id) {
            dispatch((0, get_document_elements_thunk_1.get_document_elements_thunk)({ data: { document_id } }));
        }
    }, [document_id]);
    (0, react_1.useEffect)(() => {
        if (!selectedDocumentElements || !selectedDocumentElements.length || !selectedDocument || !selectedDocument.user_id) {
            setQrCodeUrl(null);
            return;
        }
        const signatureElement = selectedDocumentElements.find((el) => el.type === "Signature");
        if (!signatureElement) {
            setQrCodeUrl(null);
            return;
        }
        const user_id = selectedDocument.user_id;
        axios_1.default
            .get(`${process.env.API_URL}/esig/qrcode?user_id=${user_id}&element_id=${signatureElement._id}`)
            .then((res) => setQrCodeUrl(res.data.qr_image_data_url))
            .catch(() => setQrCodeUrl(null));
    }, [selectedDocumentElements, selectedDocument]);
    // Match the document page's width source so the certificate column lines up with
    // the document column in the completed view. Uses the same getDocumentDimensions
    // helper that live_document.tsx uses for the document pages above this one.
    const docDimensions = (0, scaleFunction_1.getDocumentDimensions)(selectedDocument);
    const certWidth = (0, scaleFunction_1.scaleFunction)(docDimensions.width, docDimensions.width);
    const certHeight = (0, scaleFunction_1.scaleFunction)(docDimensions.height, docDimensions.width);
    const certStyle = {
        width: `${certWidth}px`,
        minHeight: `${certHeight}px`,
        height: `${certHeight}px`,
        position: "relative",
    };
    return (react_1.default.createElement("div", { className: "w-full px-2 sm:px-4" },
        react_1.default.createElement("div", { ref: certificateRef, style: {
                width: isPrint ? `${certWidth}px` : "100%",
                maxWidth: `${certWidth}px`,
                minHeight: `${certHeight}px`,
                height: isPrint ? `${certHeight}px` : "auto",
            }, className: `overflow-hidden ${isPrint ? "" : "shadow-md"} bg-tertiary m-auto` },
            react_1.default.createElement("div", { style: isPrint ? certStyle : undefined, className: "flex flex-col gap-3 sm:gap-4 border-2 sm:border-4 border-primary rounded-lg sm:rounded-[22%] bg-white m-auto p-4 sm:p-8 md:p-12 lg:p-16" },
                react_1.default.createElement("img", { src: logo_png_1.default, className: "mx-auto w-24 sm:w-32 md:w-40", style: isPrint
                        ? {
                            width: `${(0, scaleFunction_1.scaleFunction)(160)}px`,
                        }
                        : undefined }),
                react_1.default.createElement("div", { className: "font-bold text-center text-base sm:text-lg md:text-xl", style: isPrint
                        ? {
                            fontSize: `${(0, scaleFunction_1.scaleFunction)(18)}px`,
                        }
                        : undefined }, "Signature Certificate"),
                react_1.default.createElement("div", { className: "w-full h-auto sm:h-[80%] mt-3 sm:mt-6 border border-black flex flex-col gap-3 sm:gap-4 p-2 sm:p-3 md:p-4" },
                    react_1.default.createElement(Divider, { title: "Document Info" }),
                    react_1.default.createElement("div", { className: "flex flex-col gap-2 sm:gap-3 md:gap-4 p-2 sm:p-3 md:p-4" },
                        react_1.default.createElement("div", { className: "grid grid-cols-[auto_1fr] gap-2 sm:gap-4 items-start" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Document Name: ", bold: true }),
                            react_1.default.createElement("div", { className: "break-words break-all overflow-wrap-anywhere min-w-0" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.name }))),
                        react_1.default.createElement(RichText, Object.assign({}, {
                            title: "Document Status ",
                            value: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status,
                        })),
                        react_1.default.createElement(RichText, Object.assign({}, {
                            title: "Creation Date ",
                            value: (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.createdAt) && doshx_controls_web_1.Utilities.formatDateTime(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.createdAt),
                        })),
                        react_1.default.createElement(RichText, Object.assign({}, {
                            title: "Completion Date ",
                            value: (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.updatedAt) && doshx_controls_web_1.Utilities.formatDateTime(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.updatedAt),
                        }))),
                    react_1.default.createElement(Divider, { title: "Signers Details" }),
                    react_1.default.createElement("div", { className: "flex flex-col sm:flex-row gap-4 sm:gap-6 p-2 sm:p-3 md:p-4" }, signers.map((signer, index) => {
                        return (react_1.default.createElement("div", { className: "flex flex-col gap-2 sm:gap-3 md:gap-4 pb-3 sm:pb-0 border-b sm:border-b-0 last:border-b-0", key: index },
                            react_1.default.createElement("div", { className: "grid grid-cols-[auto_1fr] gap-2 sm:gap-4 items-start" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Name:", bold: true }),
                                react_1.default.createElement("div", { className: "flex flex-wrap items-center gap-2 break-words min-w-0" },
                                    react_1.default.createElement("span", { className: "break-words break-all" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: `${signer.first_name} ${signer.last_name}` })),
                                    signer.verification_status === "VERIFIED" || (!signer.verification_status && (signer.facetecDBRef || signer.facetec_verified)) ? (react_1.default.createElement("span", { className: "text-green-500 font-bold text-xs whitespace-nowrap" }, "Verified")) : signer.verification_status === "BYPASSED" ? (react_1.default.createElement("span", { className: "text-yellow-500 font-bold text-xs whitespace-nowrap" }, "Bypassed")) : (react_1.default.createElement("span", { className: "text-red-500 font-bold text-xs whitespace-nowrap" }, "Not Verified")))),
                            react_1.default.createElement(RichText, Object.assign({}, {
                                title: "Email ",
                                value: signer.email,
                            })),
                            react_1.default.createElement(RichText, Object.assign({}, {
                                title: "Location ",
                                value: (signer === null || signer === void 0 ? void 0 : signer.location_name) ||
                                    ((signer === null || signer === void 0 ? void 0 : signer.latitude) && (signer === null || signer === void 0 ? void 0 : signer.longitude) ? `${signer.latitude.toFixed(6)}, ${signer.longitude.toFixed(6)}` : ""),
                            }))));
                    })),
                    react_1.default.createElement(Divider, { title: "Audit Trail" }),
                    react_1.default.createElement("div", { className: "flex flex-col gap-2 sm:gap-3 md:gap-4 p-2 sm:p-3 md:p-4" },
                        react_1.default.createElement(RichText, Object.assign({}, {
                            title: "Document Created ",
                            value: (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.createdAt) && doshx_controls_web_1.Utilities.formatDateTime(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.createdAt),
                        })),
                        react_1.default.createElement(RichText, Object.assign({}, {
                            title: "Document Completed ",
                            value: (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.updatedAt) && doshx_controls_web_1.Utilities.formatDateTime(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.updatedAt),
                        })),
                        signers.some((s) => s.test_mode_used) && (react_1.default.createElement("div", { className: "bg-yellow-50 border border-yellow-200 rounded p-2 sm:p-3" },
                            react_1.default.createElement("div", { className: "flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2" },
                                react_1.default.createElement("span", { className: "text-yellow-600 font-bold text-xs sm:text-sm" }, "\u26A0\uFE0F Test Mode Notice:"),
                                react_1.default.createElement("span", { className: "text-yellow-800 text-xs sm:text-sm" },
                                    "This document was signed in test mode with Facial Recognition bypassed. Environment: ",
                                    process.env.NODE_ENV || "LOCAL"))))),
                    react_1.default.createElement(Divider, { title: "Certification Statement" }),
                    react_1.default.createElement("div", { className: "flex flex-col gap-2 sm:gap-3 md:gap-4 p-2 sm:p-3 md:p-4" },
                        react_1.default.createElement("div", { className: "break-words break-all overflow-wrap-anywhere min-w-0" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: `This document consists of ${pages} pages and was electronically signed through Skysign. Each signer's verification status is shown above.` })),
                        react_1.default.createElement("div", { className: "grid grid-cols-[auto_1fr] gap-2 sm:gap-4 items-start" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Page Summary:", bold: true }),
                            react_1.default.createElement("div", { className: "break-words min-w-0" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: `${pages} pages` }))))),
                qrCodeUrl && (react_1.default.createElement("div", { className: "flex flex-col items-center mt-4 sm:mt-6 md:mt-8" },
                    react_1.default.createElement("div", { className: "text-xs sm:text-sm text-gray-500 mt-2 text-center" }, "Scan the QR code to verify the certificate: "),
                    react_1.default.createElement("img", { src: qrCodeUrl, alt: "eSig QR Code", className: "w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 mt-2" })))))));
}
exports.default = CertificatePage;
const Divider = ({ title }) => {
    return (react_1.default.createElement("div", { className: "flex flex-col gap-2" },
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: title, bold: true }),
        react_1.default.createElement("hr", { className: "border border-primary" })));
};
const RichText = ({ title, value }) => {
    return (react_1.default.createElement("div", { className: "grid grid-cols-[auto_1fr] gap-2 sm:gap-4 items-start" },
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: `${title}:`, bold: true }),
        react_1.default.createElement("div", { className: "break-words break-all overflow-wrap-anywhere min-w-0" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: value }))));
};
